// angular
import { Component, Output, ViewChild, EventEmitter, Input, Inject, ViewEncapsulation, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';

// Components
import { MessageDialog } from '../messageDialog/message-dialog.component';

// Configuration 
import { Configuration } from '../../configurations/shared.config';

// Models
import { FilterCriteria, Operator, RelationalLogicalOperator } from '../../dataModels/grid-list';
import { VehicleAssociationObject, PolicyObject, PolicyGeofenceObject, RuleObject, RuleExpressionObject } from '../../dataModels/policies-tab-form';
import { LookUp, IErrorHandler, IErrorHandlerToken, LookUpTableName } from '../../dataModels/';

// Pipe
import { LocalizePipe } from '../../pipes/Localize.pipe';

// Service
import { LookupService } from '../../services/lookup.service';
import { SensorTabService } from '../../services/sensors-tab-form.service';
import { PoliciesTabService } from '../../services/policies-tab-form.service';

@Component({
    moduleId: module.id,
    selector: 'policy-tab-form',
    templateUrl: 'policies-tab-form.component.html',
    styleUrls: ["../../../assets/ra/sass/PolicyEditor.scss"],
    encapsulation: ViewEncapsulation.None
})

export class PolicyTabComponent implements OnInit {

    @ViewChild(MessageDialog) private messageDialog: MessageDialog;
    @ViewChild(NgForm) form: NgForm;
    @Input("trackedObjectId") trackedObjectId: number;
    displayExpressionBox: boolean = false;
    displayRuleForm: boolean = false;
    creationMode: boolean = false;

    operationSuccessfullMessage: boolean = false;
    hasError = void 0;
    // holds Current Policy Object
    policyObject: PolicyObject = new PolicyObject();
    // holds Current rule Object
    ruleObject: RuleObject = new RuleObject();
    geofencePolicies: PolicyObject[] = [];
    geofenceId: number = null;
    public vehicleId: number = null;
    rulesList: RuleObject[] = []; // contain rule objects for saving in DB
    ruleExpressionObjectsList: RuleExpressionObject[] = []; // contain rule Expression objects for parsing
    ruleExpressionLogicalRelations: string[] = [];
    EventTypes: any[] = [];
    selectedViewState: any = '-1';
    selectedGeoFenceRule: any = '1';
    selectedViewStateStringKey: string = '';
    enableIdentifiersSelect: boolean = false;
    enableComparsionSignSelection: boolean = false;
    // rule memebers ----------------------
    ruleParametersList: LookUp[] = [];
    ruleComparsionList: string[] = ['==', '>', '<', '>=', '<='];
    ruleValue: any = '-1';
    selectedIdentifier: string = '-1';
    selectedComparsion: string = '-1';
    notification: boolean = false;
    //applyInsideGeoFence: boolean = true;
    expression: string = "";
    CustomEventTypeName: string = "";
    eventGroup: boolean = false;
    // end of rule members ----------------
    currentPolicyId: number = 0;
    showDetailsSection: boolean = false;
    // quick policy form
    showQuickForm: boolean = false;
    //ruleType: string = ''; // value will be in or out
    isQuickRuleInChecked: boolean = false;
    isQuickRuleOutChecked: boolean = false;

    @Input() editMode: boolean = false;
    @Output() policySaveFinshed: EventEmitter<any> = new EventEmitter();
    @Output() defaultPolicyLoaded: EventEmitter<any> = new EventEmitter();
    @Output() addNewDefaultPolicyEvent: EventEmitter<any> = new EventEmitter();
    @Output() policyDeletionEvent: EventEmitter<any> = new EventEmitter();
    @Output() ruleDeletionEvent: EventEmitter<any> = new EventEmitter();

    isDefaultPolicy: boolean = false;
    filterCriteria: FilterCriteria = new FilterCriteria();
    invalidRule: boolean = false;

    selectedSensor: any = {};
    digtValues: any[] = [];
    constructor(private sensorService: SensorTabService, private policiesServices: PoliciesTabService, @Inject(IErrorHandlerToken) private errorHandler: IErrorHandler, private lookupService: LookupService, private localizer: LocalizePipe) {
        this.filterCriteria.PageSize = -1;
        this.filterCriteria.SearchCriteria = [];

    }

    ngOnInit() {
        // console.log("this.policiesServices.getSensorsSubmittedEmitter");
        this.policiesServices.getSensorsSubmittedEmitter().subscribe(id => {
            // console.log("vehicle ID is updated", id);
            // console.log("ngOnInit");
            this.vehicleId = id;
            this.getPoliciesByVid(this.vehicleId);
            this.getEventTypes();
            this.getRuleParameters();
        });
    };

    // get default policy related by Vehicle
    getPoliciesByVid(vid) {
        //console.log("getPoliciesByVid");
        //console.log("getPoliciesByVid", "vid", vid);
        let vecID = vid == null ? this.trackedObjectId : vid;
        // console.log("getPoliciesByVid", "vecID", vecID);
        this.vehicleId = vid;
        this.policyObject = new PolicyObject();
        this.ruleObject = new RuleObject();
        this.showDetailsSection = false;
        this.geofencePolicies = [];
        this.rulesList = [];
        var self = this;
        //this._http.get(api.webApiEndpoint + api.GetDefaultPolicy + vecID)
        //    .map(res => res.json())
        this.policiesServices.getDefaultPolicy(vecID)
            .subscribe(result => {
                if (result.Value) {
                    self.geofencePolicies.push(result.Value);
                    if (self.geofencePolicies.length > 0) {
                        self.isDefaultPolicy = true;
                        self.getRulesByPolicyId(self.geofencePolicies[0].Id);
                    }
                    else
                        self.isDefaultPolicy = false;
                }
                else {
                    self.isDefaultPolicy = false;
                }
                self.defaultPolicyLoaded.emit(self.geofencePolicies);
            }, error => this.errorHandler.DefaultError());
        this.getRuleParametersForVicle();
    };

    // get policies related by geofence
    getPoliciesByGid(gid) {
        // console.log("getPoliciesByGid");
        document.getElementById("geoCheckbox") ? document.getElementById("geoCheckbox").style.visibility = "visible" : "";
        this.selectedGeoFenceRule = "1";
        this.geofenceId = gid;
        this.policyObject = new PolicyObject();
        this.ruleObject = new RuleObject();
        this.showDetailsSection = false;
        this.rulesList = [];
        this.geofencePolicies = [];
        var self = this;
        //this._http.get(api.webApiEndpoint + api.GetPoliciesByGeofenceId + gid)
        //    .map(res => res.json())
        this.policiesServices.getPoliciesByGeofenceId(gid)
            .subscribe(result => {
                if (result.Value) {
                    self.geofencePolicies = result.Value;

                    if (result.Value.length != 0) {
                        self.getRulesByPolicyId(result.Value[0].Id);
                    }
                    else {
                        //self.showDetails();
                    }
                }
                else {
                    this.errorHandler.DefaultError();
                }
                self.policySaveFinshed.emit(self.geofencePolicies);
            }, error => this.errorHandler.DefaultError());

    };

    //get rules Event Types
    getEventTypes() {
        // console.log("getEventTypes");
        var self = this;
        //this._http.get(api.webApiEndpoint + api.GetNotMonitor)
        //    .map(res => res.json())
        this.policiesServices.getNotMonitor().subscribe(result => {
            if (result.Value) {
                self.EventTypes = result.Value;
                self.EventTypes.push({ EventTypeName: "Custom", UniqueKey: "Custom" });
            }
            else {
                this.errorHandler.DefaultError();
            }
        }, error => this.errorHandler.DefaultError());
    };

    //get rules view States
    getRuleParameters() {
        // console.log("getRuleParameters");
        var self = this;
        document.getElementById("geoCheckbox") ? document.getElementById("geoCheckbox").style.visibility = "hidden" : "";
        this.lookupService
            .getdboLookup(LookUpTableName.RuleParameters)
            .then(result => {
                self.ruleParametersList = result
                if (this.geofenceId == null) {
                    //var ruleParamList: LookUp[] = result;
                    var index = self.ruleParametersList.findIndex(x => x.UniqueKey == "Geofence");
                    if (index > -1)
                        self.ruleParametersList.splice(index, 1);
                }

            });
    };

    //New get rules view States from sensorInstateOfRuleParameters
    getRuleParametersForVicle() {
        // console.log("getRuleParametersForVicle");
        var self = this;
        document.getElementById("geoCheckbox") ? document.getElementById("geoCheckbox").style.visibility = "hidden" : "";
        var filterCriteria: FilterCriteria = new FilterCriteria();
        filterCriteria.PageCriteria.PageNumber = -1;
        filterCriteria.SearchCriteria.push({ Operator: Operator.Equal, SearchKey: this.vehicleId ? this.vehicleId.toString() : this.trackedObjectId.toString(), Field: "TrackedObjectId", RelationOperator: RelationalLogicalOperator.And });
        filterCriteria.SearchCriteria.push({ Operator: Operator.NotEqual, SearchKey: 0 + "", Field: "PortNumber", RelationOperator: RelationalLogicalOperator.And });
        this.sensorService.getSensorData(filterCriteria).subscribe(result => {
            self.ruleParametersList = result.Value.Collection.map(x => ({ DisplayName: x.SensorName, Id: x.Id, IsDeleted: false, LookupObjectType: x.MainSensorTypeId, UniqueKey: x.SensorNameExpression, ExtraFields: null, EventNameForZeroDigit: x.EventNameForZeroDigit, EventNameForOneDigit: x.EventNameForOneDigit }));
        });

    };

    // get rules related to certain policy Id
    getRulesByPolicyId(id) {
        // console.log("getRulesByPolicyId");
        this.showDetailsSection = true;
        this.displayRuleForm = false;
        this.showQuickForm = false;

        // to prevent go to backend in every click
        if (this.currentPolicyId != id || this.rulesList.length == 0) {
            this.currentPolicyId = id;
            var self = this;
            if (this.geofencePolicies.length > 0) {
                this.policyObject = this.geofencePolicies.find(r => r.Id == id);
                // get rules per policy
                // this._http.get(api.webApiEndpoint + api.RulesUrl + id)
                // .map(res => res.json())
                this.policiesServices.getRules(id)
                    .subscribe(result => {
                        if (result.Value) {
                            self.rulesList = result.Value;
                            this.creationMode = false;
                        }
                        else {
                            this.errorHandler.DefaultError();
                        }
                    }, err => this.errorHandler.DefaultError());
            }
        }
    };

    // save policy data to DB
    savePolicy() {
        // console.log("savePolicy");
        var self = this;
        var policyObjectId = self.policyObject.Id;
        if (self.policyObject.PolicyName == undefined || self.policyObject.PolicyName == "" || self.rulesList.length == 0) {
            this.errorHandler.Handle(this.localizer.transform(Configuration.messages.invalidInput));
            return;
        }
        //this._http.post(api.webApiEndpoint + api.SavePolicy, this.policyObject)
        //    .map(res => res.json())

        this.policiesServices.SavePolicy(this.policyObject)
            .subscribe(result => {
                if (!result.Value) {
                    return this.errorHandler.DefaultError();
                }

                self.saveRuleData(result.Value);

                if (policyObjectId == 0) {
                    // save policy geofence relation object
                    if (this.geofenceId != null) {
                        var policyGeofenceRelation = new PolicyGeofenceObject();
                        policyGeofenceRelation.GeofenceId = this.geofenceId;
                        policyGeofenceRelation.PolicyId = result.Value;
                        // save policy geofence relation
                        self.savePolicyGeofenceRelation(policyGeofenceRelation);
                        // -----------------------------------

                    }
                    else { // save vehicle association object (camne from vehicle mgmt component)
                        var vehicleAssociation = new VehicleAssociationObject();
                        vehicleAssociation.VehicleId = this.trackedObjectId && this.trackedObjectId > 0 ? this.trackedObjectId : self.vehicleId;
                        vehicleAssociation.PolicyId = result.Value;
                        //vehicleAssociation.GeofenceId = self.geofenceId; // null
                        self.savePolicyVehicleRelation(vehicleAssociation);

                    }
                }

                this.showSuccessMessage();
            }, err => this.errorHandler.DefaultError());
    };

    // Save Rule Data to DB
    saveRuleData(pid) {
        // console.log("saveRuleData");
        var self = this;
        this.ruleExpressionObjectsList = [];
        this.ruleExpressionLogicalRelations = [];
        var rules = this.rulesList.filter(r => r.Id == 0);
        if (rules && rules.length > 0) {
            // update all new rules with policy id
            for (var element of rules) {
                element.PolicyId = pid;
            }
            //this._http.post(api.webApiEndpoint + api.RulesUrl, rules)
            //    .map(res => res.json())
            this.policiesServices.saveRules(rules)
                .subscribe(result => {
                    if (!result.Value) {
                        return this.errorHandler.DefaultError();
                    }

                    this.displayRuleForm = false;
                    this.showQuickForm = false;

                    self.getEventTypes();
                    // Get all rule again and reset the rule list
                    //this._http.get(api.webApiEndpoint + api.RulesUrl + pid)
                    //    .map(res => res.json())
                    this.policiesServices.getRules(pid)
                        .subscribe(result => {
                            if (result.Value) {
                                self.rulesList = result.Value;
                            }
                            else {
                                this.errorHandler.DefaultError();
                            }
                        });
                }, error => this.errorHandler.DefaultError());
        }
    };

    // save policy geofence relation
    savePolicyGeofenceRelation(associationObject) {
        // console.log("savePolicyGeofenceRelation");
        var self = this;
        //this._http.post(api.webApiEndpoint + api.SavePolicyGeofenceAssociation, associationObject)
        //    .map(res => res.json())
        this.policiesServices.SavePolicyGeofenceAssociation(associationObject)
            .subscribe(result => {
                if (result.Value) {
                    self.getPoliciesByGid(self.geofenceId);
                }
                else {
                    this.errorHandler.DefaultError();
                }
            }, error => this.errorHandler.DefaultError());
    };

    // save vehicle ssociation relation without geofence id
    savePolicyVehicleRelation(vehicleAssociationObject) {
        // console.log("savePolicyVehicleRelation");

        var vehicleAssociationList = [];
        vehicleAssociationList.push(vehicleAssociationObject);
        var self = this;
        //this._http.post(api.webApiEndpoint + api.VehicleAssociationUrl, vehicleAssociationList)
        //    .map(res => res.json())
        this.policiesServices.savePolicyVehicleRelation(vehicleAssociationList)
            .subscribe(result => {
                if (result.Value) {
                    self.getPoliciesByVid(self.vehicleId);
                }
                else {
                    this.errorHandler.DefaultError();
                }
            }, error => this.errorHandler.DefaultError());
    };

    // emit event with deletion
    onDeletePolicy(policyId) {
        this.policyDeletionEvent.emit(policyId);
    };

    //Remove Policy With Associations
    DeletePolicy(policyId) {
        // console.log("DeletePolicy");
        var xthis = this;
        //this._http.delete(api.webApiEndpoint + api.DeletePolicy + policyId + "/" + this.geofenceId)
        //    .map(res => res.json())
        this.policiesServices.deletePolicy(policyId, this.geofenceId)
            .subscribe(result => {
                if (!result.IsErrorState && result.Value != null) {
                    if (xthis.geofenceId != null)
                        xthis.getPoliciesByGid(xthis.geofenceId);
                    else
                        xthis.getPoliciesByVid(xthis.vehicleId);
                }
                else if (result.ErrorDescription == "Policy_Has_Vehicles_Staff") {
                    this.errorHandler.Handle(this.localizer.transform("Policy_Has_Vehicles_Staff"));
                }
                else if (result.ErrorDescription == "Policy_Has_Vehicles") {
                    this.errorHandler.Handle(this.localizer.transform("Policy_Has_Vehicles"));
                }
                else if (result.ErrorDescription == "Policy_Has_Staff") {
                    this.errorHandler.Handle(this.localizer.transform("Policy_Has_Staff"));
                }
                else {
                    this.errorHandler.DefaultError();
                }
            }, error => this.errorHandler.DefaultError());
    };

    // update expression text with user input
    updateExpresion(value) {
        // console.log("updateExpresion");

        //debugger;
        if (this.selectedIdentifier == '-1' || this.ruleValue == '-1' || this.selectedComparsion == '-1') {
            this.invalidRule = true;
            this.errorHandler.Handle(this.localizer.transform("InvalidRule"));
            return;
        }

        if (!this.displayExpressionBox) {
            if (this.selectedIdentifier && (this.ruleValue || this.ruleValue == 0) && this.selectedComparsion) {
                var ruleExpObject = new RuleExpressionObject();
                if (this.ruleExpressionObjectsList.findIndex(r => r.Identifier == this.selectedIdentifier) == -1) {

                    if (value === " && ") {
                        this.displayExpressionBox = true;
                    }

                    var expr = "";
                    this.invalidRule = false;
                    ruleExpObject.Identifier = this.selectedIdentifier;
                    ruleExpObject.Operator = this.selectedComparsion;

                    // geofence View State case
                    if (this.vehicleId == null) {
                        if (this.selectedIdentifier.includes("Geofence")) {
                            if (this.geofenceId) {
                                ruleExpObject.Identifier = "g" + this.geofenceId;
                                if (this.ruleValue == "1")
                                    ruleExpObject.Value = "Geofences.Contains(";
                                else if (this.ruleValue == "0")
                                    ruleExpObject.Value = "!Geofences.Contains(";

                                // expr = this.selectedIdentifier + " With Id " + this.geofenceId + this.selectedComparsion + this.ruleValue;
                                expr = ruleExpObject.Value + this.geofenceId + ")";
                            }
                            else {
                                this.invalidRule = true;
                                this.errorHandler.Handle(this.localizer.transform("GeofenceRule_Invalid"));
                            }
                        }
                        //else if (this.selectedIdentifier.includes("Temperature")) {

                        //    expr = "(Sensors.ContainsKey(\"temperature\") && Sensors[\"temperature\"] " + this.selectedComparsion + this.ruleValue + ") ||  Temperature " + this.selectedComparsion + this.ruleValue;
                        //}
                        //else if (this.selectedIdentifier.includes("SeatBelt")) {

                        //    expr = "Seatbelt" + this.selectedComparsion + this.ruleValue;
                        //}
                        //else if (this.selectedIdentifier.includes("Ignition")) {
                        //    ruleExpObject.Identifier = this.selectedIdentifier;
                        //    if (this.ruleValue == "in")
                        //        ruleExpObject.Value = "1";
                        //    else if (this.ruleValue == "out")
                        //        ruleExpObject.Value = "0";
                        //    expr = this.selectedIdentifier + this.selectedComparsion + this.ruleValue;
                        //}
                        else if (this.selectedIdentifier.includes("Speed")) {

                            expr = "Speed" + this.selectedComparsion + this.ruleValue;
                        }
                        else {
                            if (this.ruleValue == "in")
                                ruleExpObject.Value = "1";
                            else if (this.ruleValue == "out")
                                ruleExpObject.Value = "0";
                            ruleExpObject.Value = this.ruleValue;
                            expr = '{' + this.selectedIdentifier + '}' + this.selectedComparsion + this.ruleValue;
                        }
                    }
                    //in vechil page only
                    else {

                        expr = '(Sensors.ContainsKey("' + this.selectedIdentifier + '") && Sensors["' + this.selectedIdentifier + '"]' + this.selectedComparsion + this.ruleValue + ') ';
                    }
                    if (!this.expression.includes(expr) && (this.expression.endsWith(" && ") || this.expression.endsWith(" || ") || this.expression == "")) {
                        this.expression += expr;
                    }
                    else {
                        this.ruleExpressionLogicalRelations.push(value.trim());
                        this.expression += value + expr;
                    }
                    this.ruleExpressionObjectsList.push(ruleExpObject);

                    if (value === " && ") {
                        this.selectedIdentifier = "-1";
                        this.selectedComparsion = '-1';
                        this.ruleValue = '-1';

                        this.expression = this.expression.concat(" && ");
                    }
                }
                else {
                    this.invalidRule = true;
                    this.errorHandler.Handle(this.localizer.transform("InvalidRule"));
                }
            }
        }
        else {
            this.ruleValue = "-1";
            this.selectedComparsion = "-1";
            this.selectedIdentifier = "-1";

            this.identifierIndex = 0;
            this.geofenceValueIndex = 0;
            this.operatorIndex = 0;

            this.expression = this.expression.concat(" && ");
        }
    };

    // add rule to rules List
    addRule() {
        // console.log("addRule");
        this.invalidRule = false;
        if (this.geofenceId == null) {
            if (this.selectedIdentifier == '-1' || this.ruleValue == '-1' || this.ruleValue == null || this.selectedComparsion == '-1') {

                this.invalidRule = true;
                this.errorHandler.Handle(this.localizer.transform("InvalidRule"));

                return;
            }
        }
        this.ruleObject = new RuleObject();
        if ((this.ruleExpressionObjectsList.length != 0) || (this.selectedIdentifier && (this.ruleValue || this.ruleValue == 0) && this.selectedComparsion && this.selectedViewState.UniqueKey)) {

            var action = null;
            if (!this.enableIdentifiersSelect && this.ruleExpressionObjectsList.length == 0 && this.selectedIdentifier != '-1')
                this.updateExpresion("rule");
            if (this.rulesList.findIndex(r => r.ExpressionText == this.expression)) {
                this.ruleObject.RuleViewState = this.selectedViewState.Id;
                this.ruleObject.EventTypeName = this.selectedViewState.EventTypeName;
            }
            this.ruleObject.ExpressionText = this.expression;
            this.ruleObject.ExpressionList = this.ruleExpressionObjectsList;
            this.ruleObject.ExpressionLogicalRelations = this.ruleExpressionLogicalRelations;
            if (this.notification)
                action = 1;
            else
                action = 0;
            this.ruleObject.Action = action;

            if (this.selectedViewState && this.selectedViewState.UniqueKey == "Custom" && this.selectedViewState.EventTypeName == "Custom" && this.CustomEventTypeName.trim() != "") {
                var EventType = { EventTypeName: this.CustomEventTypeName, UniqueKey: 'Custom', EventGroupId: (this.eventGroup ? 1 : 2) };
                this.ruleObject.EventType = EventType;
                this.ruleObject.EventTypeName = this.CustomEventTypeName;
            }

            else if (this.selectedViewState && this.selectedViewState.UniqueKey == "Custom" && this.selectedViewState.EventTypeName == "Custom" && this.CustomEventTypeName.trim() == "") {
                this.errorHandler.Handle(this.localizer.transform(Configuration.messages.invalidInput));
                return;
            }

            if (!this.invalidRule && !this.isRuleAddedBefore()) {
                if (this.geofenceId) {
                    if (this.selectedGeoFenceRule == '1')
                        this.ruleObject.ExpressionText = this.ruleObject.ExpressionText != "" ? "Geofences.Contains(" + this.geofenceId + ") && (" + this.ruleObject.ExpressionText + ")" : "Geofences.Contains(" + this.geofenceId + ")";
                    else
                        this.ruleObject.ExpressionText = this.ruleObject.ExpressionText != "" ? "!Geofences.Contains(" + this.geofenceId + ") && (" + this.ruleObject.ExpressionText + ")" : "!Geofences.Contains(" + this.geofenceId + ") ";

                    this.rulesList.push(this.ruleObject);
                }
                else
                    this.rulesList.push(this.ruleObject);

            }
            else {

                this.errorHandler.Handle(this.localizer.transform(Configuration.messages.RuleExist));
            }
            this.clear();
        }
        else {
            this.errorHandler.Handle(this.localizer.transform(Configuration.messages.invalidInput));

        }
    };

    // emit event on rule deletion
    onDeleteRule(rule) {
        // console.log("onDeleteRule");

        this.ruleDeletionEvent.emit(rule);
        // here should show popup of delete not delete it directily 
        //  this.deleteRule(rule);

    };

    // delete rule from DB
    deleteRule(rule) {
        // console.log("deleteRule");
        if (rule.Id == 0) {
            this.rulesList.splice(this.rulesList.indexOf(rule), 1);
        }
        else {
            rule.IsDeleted = true;
            var xthis = this;
            //this._http.delete(api.webApiEndpoint + api.RulesUrl + rule.Id)
            //    .map(res => res.json())
            this.policiesServices.deleteRule(rule.Id)
                .subscribe(result => {
                    if (!result.Value) {
                        return this.errorHandler.DefaultError();
                    }

                    this.rulesList.splice(this.rulesList.indexOf(rule), 1);
                    if (this.rulesList.length > 0) {
                        var ruleObjectIndex = this.ruleExpressionObjectsList.findIndex(r => r.Identifier == xthis.selectedIdentifier);
                        if (ruleObjectIndex) {
                            this.ruleExpressionObjectsList.splice(ruleObjectIndex, 1);
                        }
                    } else {
                        this.geofencePolicies = this.geofencePolicies.filter(x => x.Id !== rule.PolicyId);
                        if (!this.geofencePolicies.length) {
                            this.reset();
                        }
                    }

                    this.showSuccessMessage();
                }, error => this.errorHandler.DefaultError());
        }
    };

    displayRuleFormfn() {
        // console.log("displayRuleFormfn");
        this.displayRuleForm = true;
    };

    // clear expression text
    clear() {
        // console.log("clear");
        this.ruleExpressionObjectsList = [];
        this.expression = this.CustomEventTypeName = "";
        this.ruleValue = "-1";
        this.selectedComparsion = "-1";
        this.selectedIdentifier = "-1";
        this.selectedViewState = "-1";
        this.selectedGeoFenceRule = '1';
        this.displayExpressionBox = false;
        this.identifierIndex = 0;
        this.geofenceValueIndex = 0;
        this.operatorIndex = 0;

        //this.ruleType = "";
        this.isQuickRuleInChecked = false;
        this.isQuickRuleOutChecked = false;
        this.notification = false;
    };

    // Identifier Changed
    identifierChanged() {
        // console.log("identifierChanged");
        this.digtValues = [];
        if (this.vehicleId == null) {
            if (this.selectedIdentifier) {
                switch (this.selectedIdentifier) {
                    //  case "Time": this.enableComparsionSignSelection = true; break;
                    case "Temperature": this.enableComparsionSignSelection = true; break;
                    case "Speed": this.enableComparsionSignSelection = true; break;
                    case "Ignition": this.enableComparsionSignSelection = false; this.selectedComparsion = '=='; break;
                    case "Geofence": this.enableComparsionSignSelection = false; this.selectedComparsion = '=='; break;
                    case "SeatBelt": this.enableComparsionSignSelection = false; this.selectedComparsion = '=='; break;
                    case "Door": this.enableComparsionSignSelection = false; this.selectedComparsion = '=='; break;
                    // case "Movement": this.enableComparsionSignSelection = false; this.selectedComparsion = '=='; break;
                    // case "Panic": this.enableComparsionSignSelection = false; this.selectedComparsion = '=='; break;
                    // case "Disconnected": this.enableComparsionSignSelection = false; this.selectedComparsion = '=='; break;
                }


                if (this.selectedIdentifier.includes("Speed"))
                    this.writeIdentifierInExpressionBox(this.selectedIdentifier);
                else
                    this.writeIdentifierInExpressionBox('{' + this.selectedIdentifier + '}');

                this.writeSelectedComparsionInExpressionBox();
            }
        }
        else {
            //var TypeSensor = this.ruleParametersList.find(s => s.UniqueKey == this.selectedIdentifier);
            //if (TypeSensor.LookupObjectType == 2) {
            //    this.enableComparsionSignSelection = false; this.selectedComparsion = '==';
            //}
            if (this.selectedIdentifier.includes("Digt-")) {
                this.enableComparsionSignSelection = false; this.selectedComparsion = '==';
                this.selectedSensor = this.ruleParametersList.filter(x => x["UniqueKey"] == this.selectedIdentifier)[0];
                this.digtValues = [this.selectedSensor.EventNameForZeroDigit, this.selectedSensor.EventNameForOneDigit];
            }
            else { this.enableComparsionSignSelection = true }
            this.writeIdentifierInExpressionBox('(Sensors.ContainsKey("' + this.selectedIdentifier + '") && Sensors["' + this.selectedIdentifier + '"]');
            this.writeSelectedComparsionInExpressionBox();
        }
    };

    identifierIndex: number = 0;
    geofenceValueIndex: number = 0;
    operatorIndex: number = 0;

    writeIdentifierInExpressionBox(identifier: string) {
        // console.log("writeIdentifierInExpressionBox");

        if (this.displayExpressionBox) {

            if (this.identifierIndex === 0) {
                this.expression = this.expression.concat(identifier);
                this.identifierIndex = this.expression.lastIndexOf(identifier);
            }
            else {
                this.expression = this.expression.substring(0, this.identifierIndex);
                this.expression = this.expression.concat(identifier);
                this.operatorIndex = 0;
            }

            this.ruleValue = "-1";
        }
    };

    writeSelectedComparsionInExpressionBox() {
        // console.log("writeSelectedComparsionInExpressionBox");

        if (this.displayExpressionBox && this.selectedComparsion !== "-1") {

            if (this.operatorIndex === 0) {
                this.expression = this.expression.concat(this.selectedComparsion);
                this.operatorIndex = this.expression.lastIndexOf(this.selectedComparsion);
                this.geofenceValueIndex = this.operatorIndex + 1;
            }
            else {
                this.expression = this.expression.substring(0, this.operatorIndex);
                this.expression = this.expression.concat(this.selectedComparsion);
                this.geofenceValueIndex = 0;
                this.writeGeofenceValueInExpressionBox();
            }
        }
    };

    writeGeofenceValueInExpressionBox() {
        // console.log("writeGeofenceValueInExpressionBox");
        //debugger;
        if (this.displayExpressionBox && this.ruleValue !== "-1" && this.selectedComparsion !== "-1") {

            if (this.geofenceValueIndex === 0) {
                this.expression = this.expression.concat(this.ruleValue);
                this.geofenceValueIndex = this.expression.lastIndexOf(this.ruleValue);
            }
            else {
                var index = this.expression.lastIndexOf(this.selectedComparsion);
                this.expression = this.expression.substring(0, index + this.selectedComparsion.length) + this.ruleValue + (this.vehicleId != null ? ')' : '');
                // this.expression = this.expression.concat(this.ruleValue);
            }
        }
    };


    //Show Details
    showDetails() {
        // console.log("showDetails");

        this.policyObject = new PolicyObject();
        this.form.resetForm();

        setTimeout(() => {
            this.selectedIdentifier = "-1";
            this.selectedComparsion = '-1';
            this.ruleValue = '-1';
            this.selectedViewState = '-1';
            this.notification = false;

            this.creationMode = true;
            this.selectedGeoFenceRule = '1';
            this.displayRuleForm = true;

            this.showDetailsSection = true;
            this.ruleObject = new RuleObject();
            this.rulesList = [];

            this.showQuickForm = false;

            this.addNewDefaultPolicyEvent.emit("Default Policy");
        }, 0);
    };

    // display quick policy form
    displayQuickForm() {
        // console.log("displayQuickForm");

        this.policyObject = new PolicyObject();
        this.form.resetForm();

        setTimeout(() => {
            this.displayRuleForm = false;
            this.showDetailsSection = true;

            this.creationMode = true;
            this.ruleObject = new RuleObject();
            this.rulesList = [];
            this.notification = false;

            //this.ruleType = '';
            this.isQuickRuleInChecked = false;
            this.isQuickRuleOutChecked = false;
            this.showQuickForm = true;
        }, 0);
    };

    // add quick rule
    addQuickRule() {
        // console.log("addQuickRule");
        if (this.isQuickRuleOutChecked) {
            this.evaluateQuickPolicy("out");
        }
        if (this.isQuickRuleInChecked) {
            this.evaluateQuickPolicy("in");
        }
    };

    reset() {
        // console.log("reset");
        this.form.resetForm();
        setTimeout(() => {
            this.selectedIdentifier = "-1";
            this.selectedComparsion = '-1';
            this.ruleValue = '-1';
            this.selectedViewState = '-1';
            this.selectedGeoFenceRule = '1';
        }, 0);
        this.displayExpressionBox = false;
        this.identifierIndex = 0;
        this.geofenceValueIndex = 0;
        this.operatorIndex = 0;

        this.creationMode = false;

        this.showDetailsSection = false;
        this.policyObject = new PolicyObject();
        this.rulesList = [];
        this.isDefaultPolicy = false;
        this.displayRuleForm = false;

        this.showQuickForm = false;
        //this.ruleType = '';
        this.isQuickRuleInChecked = false;
        this.isQuickRuleOutChecked = false;
    };

    ngAfterViewInit() {
        this.geofenceId = this.vehicleId = null;
        this.getEventTypes();
        this.getRuleParameters();
    };

    isRuleAddedBefore() {
        // console.log("isRuleAddedBefore");
        if (this.selectedViewState.UniqueKey == "Custom")
            return false;
        return this.rulesList.findIndex(s => s.RuleViewState == this.selectedViewState.Id) > -1;
    };

    onKeyPress(e) {
        // console.log("onKeyPress");
        var regex = new RegExp("^[a-zA-Z0-9\-\_]+$");
        var key = String.fromCharCode(!e.charCode ? e.which : e.charCode);
        if (!regex.test(key)) {
            event.preventDefault();
            return false;
        }
    };

    private successMessageTimeout;

    private showSuccessMessage() {
        // console.log("showSuccessMessage");

        this.operationSuccessfullMessage = true;
        // clear the old Timeout (if exists)
        clearTimeout(this.successMessageTimeout);
        // start a new Timeout
        this.successMessageTimeout = setTimeout(() => this.operationSuccessfullMessage = false, 3000);
    };

    private evaluateQuickPolicy(ruleType) {
        // console.log("evaluateQuickPolicy");
        if (ruleType !== "") {
            const getEvent = (eventkey: string) => this.EventTypes.find(e => e.UniqueKey.toLowerCase() === eventkey.toLowerCase());
            const eventType = getEvent(ruleType === "in" ? "GeoInViolation" : "GeoOutViolation");

            if (this.rulesList.findIndex(s => s.RuleViewState == eventType.Id) === -1) {
                this.ruleObject = this.ruleObject.ExpressionText ? new RuleObject() : this.ruleObject;

                if (ruleType === 'in') {
                    this.ruleObject.ExpressionText = "Geofences.Contains(" + this.geofenceId + ")";
                }
                else {
                    this.ruleObject.ExpressionText = "!Geofences.Contains(" + this.geofenceId + ")";
                }

                this.ruleObject.RuleViewState = eventType.Id;
                this.ruleObject.EventTypeName = eventType.EventTypeName;

                if (this.notification) {
                    this.ruleObject.Action = 1;
                }
                else {
                    this.ruleObject.Action = 0;
                }

                this.rulesList.push(this.ruleObject);
                ruleType = "";
            }
            else {
                this.errorHandler.Handle(this.localizer.transform(Configuration.messages.RuleExist));
            }
        }
        else {
            this.errorHandler.Handle(this.localizer.transform(Configuration.messages.invalidInput));
        }
    };
};


 //custome-input-geofence if button show 

 //custome-input-geofence-no-btn  if button hidden


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/policiesTabForm/policies-tab-form.component.ts